import { useState } from 'react';

export default function Terms() {
  const [activeTab, setActiveTab] = useState<'terms' | 'refund'>('terms');
  
  return (
    <section id="terms" className="py-24 bg-gradient-to-b from-white to-orange-50 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">환불 및 이용약관</h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center mb-10">
            <div className="inline-flex bg-gray-100 rounded-full p-1">
              <button
                onClick={() => setActiveTab('terms')}
                className={`px-8 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'terms'
                    ? 'bg-orange-500 text-white shadow-md'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                이용약관
              </button>
              <button
                onClick={() => setActiveTab('refund')}
                className={`px-8 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === 'refund'
                    ? 'bg-orange-500 text-white shadow-md'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                환불정책
              </button>
            </div>
          </div>
          
          {activeTab === 'terms' && (
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
              <div className="h-[500px] overflow-y-auto pr-4 custom-scrollbar">
                <div className="space-y-8">
                  <div className="text-center mb-6">
                    <h3 className="text-3xl font-bold text-gray-900 mb-2">PLAY PLACE</h3>
                    <p className="text-lg text-orange-600 font-semibold">시간제 요금 및 시설 이용 약관</p>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제1조 (목적)</h3>
                    <p className="text-gray-700 leading-relaxed">
                      본 약관은 PLAY PLACE가 제공하는 시간제 시설 이용 서비스에 대하여,
                      시설 이용에 따라 부과되는 시간제 요금의 결제, 이용, 환불 및 책임 사항을 규정함을 목적으로 한다.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제2조 (서비스의 성격)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 본 서비스는 PC방, 공유공간과 유사한 시간제 공간 이용 서비스이다.</p>
                      <p>• 이용자는 시설을 이용하는 시간에 따라 시간제 요금을 부담한다.</p>
                      <p>• 본 서비스는 상금, 환전, 보상, 재산적 가치 제공과는 무관하다.</p>
                      <p>• 시설 이용과 관련된 결과, 기록, 순위 등은 어떠한 법적·금전적 효력을 가지지 않는다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제3조 (시간제 요금의 의미)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 시간제 요금이란, 이용자가 PLAY PLACE 시설에 머무르며 공간 및 설비를 이용하는 동안 발생하는 이용 시간에 대한 대가를 말한다.</p>
                      <p>• 시설을 이용하는 행위 자체가 시간제 요금 부과의 기준이 된다.</p>
                      <p>• 시간제 요금은 게임, 포인트, 코인, 랭킹, 기록과 관계없이 부과된다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제4조 (결제 방식)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 모든 시간제 요금은 사전 선결제 방식으로만 운영된다.</p>
                      <p>• 후불 결제는 제공되지 않는다.</p>
                      <p>• 결제는 웹앱 또는 매장에서 진행할 수 있다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제5조 (이용 시간 및 요금 기준)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 시설 이용의 최소 결제 시간은 1시간이다.</p>
                      <p>• 최초 1시간 이후 추가 이용 시간은 30분 단위로 요금이 부과된다.</p>
                      <p>• 결제된 시간은 실제 이용 여부와 관계없이 차감된다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제6조 (이용 개시 기준)</h3>
                    <p className="text-gray-700 leading-relaxed mb-3">
                      다음 각 호 중 하나라도 해당하는 경우, 시설 이용이 개시된 것으로 본다.
                    </p>
                    <div className="space-y-2 text-gray-700 leading-relaxed">
                      <p>• 시설 출입</p>
                      <p>• 좌석 또는 공간 배정</p>
                      <p>• 이용 시간 시작</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제7조 (환불 규정)</h3>
                    <div className="space-y-4">
                      <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                        <h5 className="font-bold text-gray-900 mb-2">① 이용 개시 이후</h5>
                        <div className="space-y-2 text-gray-700 leading-relaxed">
                          <p>• 시설 이용이 개시된 이후에는 시간제 요금의 환불이 불가하다.</p>
                          <p>• 이는 시간 소모형 서비스의 특성에 따른 것으로, PC방 등 유사 시간제 시설과 동일한 기준을 적용한다.</p>
                          <p>• 조기 종료, 개인 사정, 미이용 시간은 환불 사유에 해당하지 않는다.</p>
                        </div>
                      </div>
                      <div className="bg-green-50 rounded-lg p-4 border-l-4 border-green-500">
                        <h5 className="font-bold text-gray-900 mb-2">② 이용 개시 이전</h5>
                        <div className="space-y-2 text-gray-700 leading-relaxed">
                          <p>• 시설 이용 개시 전에는 환불 신청이 가능하다.</p>
                          <p>• 환불은 이메일 문의 접수 방식으로만 진행된다.</p>
                          <p>• 환불 처리 기준 및 기간은 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관계 법령에 따른다.</p>
                          <p>• 결제 수단에 따른 수수료는 차감될 수 있다.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제8조 (시간제 요금의 사용 기한 및 소멸)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 결제된 시간제 요금의 사용 기한은 결제일로부터 3개월이다.</p>
                      <p>• 결제 후 3개월간 시설 이용 내역이 없는 경우, 해당 시간제 요금은 자동 소멸된다.</p>
                      <p>• 소멸된 요금은 환불, 연장, 복구가 불가하다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제9조 (시설 이용 종료 및 체크아웃 의무)</h3>
                    <div className="bg-yellow-50 rounded-lg p-4 border-l-4 border-yellow-500">
                      <div className="space-y-3 text-gray-700 leading-relaxed">
                        <p>• 시설 이용 종료 시, 이용자는 반드시 <strong>체크아웃(이용 종료 처리)</strong>을 완료해야 한다.</p>
                        <p>• 체크아웃을 하지 않은 상태로 시설을 이탈한 경우, 해당 시점 이후 발생하는 모든 시간제 요금 및 이용 관련 책임은 이용자 본인에게 귀속된다.</p>
                        <p>• 체크아웃 미이행으로 인해 발생한 추가 요금, 시간 초과, 시스템상 이용 지속 처리 등에 대하여 PLAY PLACE 및 매장은 책임을 지지 않는다.</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제10조 (강제 종료 요청)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 이용자가 정상적인 체크아웃이 어려운 상황에서 시설 이용을 즉시 종료하고자 하는 경우, 반드시 해당 매장으로 직접 연락하여 강제 종료를 요청해야 한다.</p>
                      <p>• 강제 종료는 매장의 확인 및 처리 절차에 따라 이루어진다.</p>
                      <p>• 매장에 연락 없이 이용자가 일방적으로 시설을 이탈한 경우, 강제 종료는 인정되지 않는다.</p>
                      <p>• 강제 종료 요청 이전까지 발생한 시간제 요금은 정상 부과된다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제11조 (포인트·코인과의 무관성)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• PLAY PLACE는 포인트 또는 코인의 발급·관리 주체가 아니다.</p>
                      <p>• 시간제 요금 결제는 포인트, 코인, 랭킹, 기록과 법적·금전적으로 완전히 분리된다.</p>
                      <p>• 시간제 요금 결제는 어떠한 보상이나 결과를 보장하지 않는다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제12조 (이용자의 책임)</h3>
                    <div className="space-y-3 text-gray-700 leading-relaxed">
                      <p>• 이용자는 결제 전 이용 시간, 요금 기준, 환불 규정, 사용 기한 및 체크아웃 의무를 충분히 확인해야 한다.</p>
                      <p>• 결제 완료 시 본 약관에 동의한 것으로 본다.</p>
                      <p>• 이용자의 고의 또는 과실로 발생한 시설 손해는 배상 책임이 발생할 수 있다.</p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">제13조 (약관의 변경)</h3>
                    <p className="text-gray-700 leading-relaxed">
                      본 약관은 관련 법령을 준수하는 범위 내에서 변경될 수 있으며, 변경 시 홈페이지를 통해 사전 안내한다.
                    </p>
                  </div>

                  <div className="bg-orange-50 rounded-lg p-6 mt-8">
                    <p className="text-sm text-gray-600 text-center">
                      본 약관은 2026년 1월 1일부터 시행됩니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'refund' && (
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
              <div className="h-[500px] overflow-y-auto pr-4 custom-scrollbar">
                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">환불 정책 안내</h3>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      PLAY PLACE의 환불 정책은 공정거래위원회가 고시한 소비자분쟁해결기준에 따라 처리됩니다.
                    </p>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-green-50 rounded-xl p-6 border-2 border-green-200">
                      <div className="flex items-center justify-center mb-4">
                        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center">
                          <i className="ri-checkbox-circle-line text-3xl text-white"></i>
                        </div>
                      </div>
                      <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">환불 가능</h4>
                      <ul className="space-y-3">
                        <li className="flex items-start">
                          <i className="ri-check-line text-green-500 mt-1 mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">이용 시작 전 환불 가능</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-check-line text-green-500 mt-1 mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">매장 정책에 따라 처리</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-check-line text-green-500 mt-1 mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">시스템 오류로 인한 결제 시 전액 환불</span>
                        </li>
                      </ul>
                    </div>
                    
                    <div className="bg-red-50 rounded-xl p-6 border-2 border-red-200">
                      <div className="flex items-center justify-center mb-4">
                        <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center">
                          <i className="ri-close-circle-line text-3xl text-white"></i>
                        </div>
                      </div>
                      <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">환불 불가</h4>
                      <ul className="space-y-3">
                        <li className="flex items-start">
                          <i className="ri-close-line text-red-500 mt-1 mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">이용 시작 후</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-close-line text-red-500 mt-1 mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">개인 사정에 의한 이용 중단</span>
                        </li>
                        <li className="flex items-start">
                          <i className="ri-close-line text-red-500 mt-1 mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">매장 이용 제한 발생 시</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">환불 처리 기준</h3>
                    <div className="space-y-4 text-gray-700 leading-relaxed">
                      <div className="bg-gray-50 rounded-lg p-4">
                        <h5 className="font-bold text-gray-900 mb-2">1. 이용 시작 전 취소</h5>
                        <p>이용 시작 시간 이전에 취소하는 경우 전액 환불이 가능합니다.</p>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-4">
                        <h5 className="font-bold text-gray-900 mb-2">2. 이용 시작 후 취소</h5>
                        <p>이용 시작 후에는 환불이 불가능합니다. 단, 회사의 귀책사유로 서비스 제공이 불가능한 경우 전액 환불됩니다.</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">환불 처리 절차</h3>
                    <div className="space-y-4">
                      <div className="flex items-start">
                        <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">1</div>
                        <div className="ml-4">
                          <h5 className="font-bold text-gray-900 mb-1">환불 신청</h5>
                          <p className="text-gray-700">매장 직원 또는 고객센터를 통해 환불을 신청합니다.</p>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">2</div>
                        <div className="ml-4">
                          <h5 className="font-bold text-gray-900 mb-1">내용 확인</h5>
                          <p className="text-gray-700">환불 사유 및 이용 내역을 확인합니다.</p>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">3</div>
                        <div className="ml-4">
                          <h5 className="font-bold text-gray-900 mb-1">환불 처리</h5>
                          <p className="text-gray-700">승인 후 3-5 영업일 내 환불이 완료됩니다.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-yellow-50 rounded-xl p-6 border border-yellow-200">
                    <div className="flex items-start">
                      <i className="ri-alert-line text-yellow-600 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                      <div>
                        <h5 className="font-bold text-gray-900 mb-2">중요 고지 사항</h5>
                        <ul className="space-y-2 text-gray-700">
                          <li>• 환불 기준은 매장별 정책이 우선 적용됩니다.</li>
                          <li>• 신용카드 결제의 경우 카드사 정책에 따라 환불 처리 기간이 달라질 수 있습니다.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
